import * as React from "react";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import Stack from "@mui/material/Stack";
import { styled, Typography } from "@mui/material/";

const CustomTypo = styled(Typography)((color) => ({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "160%",
  textTransform: "none",
  letterSpacing: "0.015em",
  color: color,
}));

export default function LongButton({
  title,
  variant,
  width = 254,
  bg = "#2B817B",
  color = "#ffffff",
  forceChangeColor,
  ...others
}) {
  return (
    <Button
      variant={variant}
      style={{
        width: width,
        marginTop: "10px",
        display:"flex",
        alignItems:"center",
        justifyContent:"flex-start",
        textAlign: "left",
        backgroundColor: variant !== "outlined" ? bg : undefined,
        border:forceChangeColor && variant === "outlined"?`1px solid ${forceChangeColor?"#DD7474":color}`:undefined
      }}
      startIcon={
        <i
          className="fas fa-arrow-left"
          style={{ color: !forceChangeColor && variant === "outlined" ? "#9EA3AE":color, fontSize: "12px" }}
        ></i>
      }
      {...others}

    >
      <CustomTypo color={!forceChangeColor && variant === "outlined" ? "#9EA3AE":color}>{title}</CustomTypo>
    </Button>
  );
}
